<div class="chart-types-list">
    <div class="icon-wrapper" [class.hide]="chartNotAvailable(chart)" *ngFor="let chart of componentCharts?.chartTypes" [class.selected]="isSelected(chart)" (click)="emitEvent(chart)">
        <i [class]="getChartTypeIcon(chart)"></i>
        <div>{{getChartTypeName(chart)}}</div>
    </div>
</div>